import React, { useEffect, useState } from 'react';
import './SellersEngagementDocuments.scss';
import filterFactory, {
    FILTER_TYPES,
} from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import moment from 'moment';
import { useStateSelector } from '../../../../store/selectors';
import { EngagementDocument } from '../../../../slices/marketplace/timeline/models/engagement-document';
import { useDispatch } from 'react-redux';
import {
    TableFilter,
    TimelineDocumentsTableFilter,
} from '../../../../components/Table/models/table-filter';
import { GetEngagementDocuments } from '../../../../slices/marketplace/timeline/thunks/get-engagement-documents.thunk';
import {
    EngagementDocumentSource,
    EngagementDocumentSourceOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-source';
import {
    EngagementDocumentStatus,
    EngagementDocumentStatusOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-status';
import {
    EngagementDocumentCounterParty,
    EngagementDocumentCounterPartyOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-counter-party';
import {
    ActionDocumentType,
    DocumentDetailsTypesOptions,
} from '../../../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';
import { DocumentDetails } from '../../../../slices/marketplace/timeline/models/document-details.model';
import createNotification from '../../../../utils/createNotification';
import EngagementDocumentPdfPreview from '../EngagementDocumentPdfPreviewModal/EngagementDocumentPdfPreviewModal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import { USER_ROLES } from '../../../../utils/constants';
import { DocumentSignModal } from '../../../../components/DocumentSignModal/DocumentSignModal';
import { Button } from 'reactstrap';
import { TimelineEventStatus } from '../../../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import EngagementDocumentUploadModal from '../EngagementDocumentUploadModal/EngagementDocumentUploadModal';
import { EngagementBuyer } from '../../../../slices/marketplace/timeline/models/engagement-buyer.model';
import BuyerProfilePreviewPopup from '../../../../components/BuyerProfilePreviewPopup/BuyerProfilePreviewPopup';
import CollapsibleComponent from '../../../../components/Collapsible/CollapsibleComponent';
import { DocumentDetailsContentType } from '../../../../slices/marketplace/timeline/models/enums/document-details-content-type';
import { LevelOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import ContactSupportButton from '../../../ContactSupportButton/ContactSupportButton';
import { SupportContextEnum } from '../../../../support-portal/models/SupportContext';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import { EngagementProcessStatus } from '../../../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';
import { useNavigate } from 'react-router-dom';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { useCurrentMarketplaceParty } from '../../../../custom-hooks/useCurrentMarketplaceParty';
import ProjectItemViewPopup from '../../ProjectItemViewPopup/ProjectItemViewPopup';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import ManualFileUploadPopup from './ManualFileUploadPopup/ManualFileUploadPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import EditDocumentNamePopup from './EditDocumentNamePopup/EditDocumentNamePopup';
import { GetTimelineById } from '../../../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { LinkedDataRequestProjectStatus } from '../../../../slices/marketplace/timeline/models/enums/linked-data-request-project-status.enum';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { NotificationFlag } from '../../../../components/NotificationFlag/NotificationFlag';

interface EngagementDocumentWithSelect extends EngagementDocument {
    isSelected: boolean;
    isDisabled: boolean;
}

interface SellersEngagementDocumentsSectionProps {
    timelineId: number;
    engagementDocumenstSection: DocumentSection;
    buttonsSection: React.JSX.Element;
    isSelectModeEnabled: boolean;
    selectedDocumentsIds: string[];
    onDocumentSelected: (documentId: string) => void;
    isAdminView: boolean;
    downloadableDocDetailsFilterCondition: (
        t: DocumentDetails | EngagementDocument
    ) => boolean;
    isGettingForSign: boolean;
    setIsGettingForSign: (isGettingForSign: boolean) => void;
    preSelectedDocumentId?: string;
    resetPreSelectedDocumentId?(): void;
    setDownloadableDocumentsIds: (ids: string[]) => void;
    isReadOnly?: boolean;
}

const SellersEngagementDocumentsSection = (
    props: SellersEngagementDocumentsSectionProps
) => {
    const axios = useStateSelector((t) => t.core.axios);
    const navigate = useNavigate();
    const party = useCurrentMarketplaceParty();
    const isAdmin = party === TimelineParty.VetValue;
    const isBroker = party === TimelineParty.Broker;

    const engagementDocuments = useStateSelector(
        (t) =>
            t.timelines.engagementDocumentsTables[
                props.engagementDocumenstSection.id
            ]
    );
    const timeline = useStateSelector((t) => t.timelines.currentTimeline);
    const dispatch = useDispatch() as any;
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(
        props.preSelectedDocumentId
    );

    const [documents, setDocuments] = useState<EngagementDocumentWithSelect[]>(
        []
    );
    const [page, setPage] = useState(1);
    const [totalSize, setTotalSize] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(5000);

    const [currentSort, setCurrentSort] = useState<TableFilter>(
        new TableFilter({ filters: [], logic: '' }, page, sizePerPage, {
            dir: 'asc',
            field: 'id',
        })
    );

    const [isProjectItemViewPopupVisible, setIsProjectItemViewPopupVisible] =
        useState(false);
    const [linkedProjectToView, setLinkedProjectToView] =
        useState<LinkedDataRequestProject>();
    const [questionnaireDocument, setQuestionnaireDocument] =
        useState<EngagementDocument>();

    const [isBuyerProfilePopupVisible, setIsBuyerProfilePopupVisible] =
        useState(false);
    const [selectedEngagedBuyer, setSelectedEngagedBuyer] =
        useState<EngagementBuyer>(null);

    const [isDocModalVisible, setIsDocModalVisible] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [documentToSign, setDocumentToSign] = useState<number>();
    const [documentToSignId, setDocumentToSignId] = useState<string>();
    const [documentToUploadFile, setDocumentToUploadFile] = useState<string>();
    const [manualDocumentToUpdate, setManualDocumentToUpdate] =
        useState<string>();
    const [isApprovalPopupVisible, setIsApprovalPopupVisible] = useState(false);
    const [documentApprovalPopupHeader, setDocumentApprovalPopupHeader] =
        useState('');
    const [isMultiDocumentApproval, setIsMultiDocumentApproval] =
        useState(false);
    const singleDocBody =
        "By clicking 'Confirm Approval', I acknowledge that I have reviewed this document " +
        'and authorize its distribution to the selected buyers.';
    const dfmDocBody =
        "By clicking 'Confirm Approval', I confirm that I have reviewed all documents in this section, including the detailed financial model and employee roster maps, and I authorize their distribution to the selected buyers.";
    const multiDocBody =
        "By clicking 'Confirm Approval', I acknowledge that I have reviewed this document and its version " +
        'and authorize their distribution to the selected buyers.';

    const [isDocConfirming, setIsDocConfirming] = useState(false);
    const [documentWithFeedbackId, setDocumentWithFeedbackId] =
        useState<string>();
    const [documentToEditName, setDocumentToEditName] =
        useState<EngagementDocument>();

    useEffect(() => {
        if (documentToSignId) {
            getDocumentToSign(documentToSignId);
        }
    }, [documentToSignId]);

    useEffect(() => {
        if (
            documents &&
            selectedDocumentId &&
            documents.some((d) => d?.id === selectedDocumentId)
        ) {
            setIsExpanded(true);
        }
    }, [props.preSelectedDocumentId, documents]);

    useEffect(() => {
        if (props.isGettingForSign) {
            setDocuments(
                documents.map((doc) => ({ ...doc, isDisabled: true }))
            );
        } else {
            setDocuments(
                documents.map((doc) => ({ ...doc, isDisabled: false }))
            );
        }
    }, [props.isGettingForSign]);

    useEffect(() => {
        const documentsCopy = documents.map((doc) => {
            return {
                ...doc,
                isSelected: props.selectedDocumentsIds.includes(doc?.id),
            };
        });
        setDocuments(documentsCopy);
    }, [props.selectedDocumentsIds]);

    useEffect(() => {
        resetHighlighting();
    }, []);

    useEffect(() => {
        fetchEngagementDocuments(currentSort);
    }, [timeline]);

    const resetHighlighting = () => {
        setTimeout(() => {
            props.resetPreSelectedDocumentId();
            setSelectedDocumentId(null);
        }, 2000);
    };

    const fetchEngagementDocuments = async (sort?: TableFilter) => {
        await dispatch(
            GetEngagementDocuments({
                timelineId: props.timelineId,
                sectionId: props.engagementDocumenstSection.id,
                filterParams: {
                    ...(sort ?? currentSort),
                    pageSize: sizePerPage,
                    pageNumber: page,
                },
            })
        );
    };

    const fetchEngagement = async () => {
        await dispatch(
            GetTimelineById({ id: props.timelineId, isTemplate: false })
        );
    };

    const initiate = async () => {
        await fetchEngagementDocuments();
    };

    useEffect(() => {
        initiate().then();
    }, []);

    useEffect(() => {
        props.setDownloadableDocumentsIds(
            (engagementDocuments?.engagementDocuments ?? [])
                .filter((doc) =>
                    props.downloadableDocDetailsFilterCondition(doc)
                )
                .map((doc) => doc?.id)
        );
        if (engagementDocuments) {
            setDocuments(
                engagementDocuments.engagementDocuments as Array<EngagementDocumentWithSelect>
            );
            setPage(engagementDocuments.pageNumber);
            setTotalSize(engagementDocuments.totalItems);
            setSizePerPage(engagementDocuments.pageSize);
        }
    }, [engagementDocuments]);

    const getEventForDocument = (documentId: string) =>
        timeline.events.find(
            (event) => event.linkedAction?.referenceItemId === documentId
        );

    const getPdfUrl = (docId: string) => {
        axios
            .get(
                `/api/marketplace/engagements/${props.timelineId}/documentsDetails/${docId}`
            )
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while getting Document',
                        'error'
                    );
                    return;
                }
                setPdfUrl(response.data);
                setIsDocModalVisible(true);
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while getting Document',
                    'error'
                );
            });
    };

    const defaultSorted: [{ dataField: any; order: any }] = [
        {
            dataField: 'name',
            order: 'asc',
        },
    ];

    const handleTableChange = (_type: any, newState: any) => {
        const { page, sizePerPage, sortField, sortOrder } = newState;
        const updatedPostObj = new TimelineDocumentsTableFilter(
            { filters: [], logic: '' },
            page,
            sizePerPage,
            { dir: sortOrder, field: sortField }
        );

        const arrayOfObj = Object.entries(newState.filters).map((e) => ({
            [e[0]]: e[1],
        }));

        if (arrayOfObj.length > 0) {
            arrayOfObj.forEach((element) => {
                let key = Object.keys(element);

                let values = newState.filters[key.toString()];

                if (
                    values.filterType != FILTER_TYPES.DATE ||
                    values.filterVal.date != null
                ) {
                    let obj = {
                        Field: key[0],
                        Operator:
                            values.filterType == FILTER_TYPES.DATE ||
                            values.filterType == FILTER_TYPES.SELECT
                                ? 'eq'
                                : 'contains',
                        Value:
                            values.filterType == FILTER_TYPES.DATE
                                ? moment(values.filterVal.date).format(
                                      'MM.DD.YYYY'
                                  )
                                : values.filterVal,
                    };

                    updatedPostObj.filter.filters.push(obj);
                }
            });
        }

        setCurrentSort(updatedPostObj);

        fetchEngagementDocuments(updatedPostObj);
    };

    const getDocumentToSign = (documentId: string) => {
        props.setIsGettingForSign(true);
        axios
            .post(
                `/api/marketplace/engagements/${props.timelineId}/documents/${documentId}/sign`,
                []
            )
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while getting Document',
                        'error'
                    );
                    return;
                }
                setDocumentToSign(response.data);
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while getting Document',
                    'error'
                );
            })
            .finally(() => {
                props.setIsGettingForSign(false);
                setDocumentToSignId(undefined);
            });
    };

    const fetchDocument = async (documentId: string) => {
        const queryParams = `documentDetailsIds=${documentId}`;
        const response = await axios.get(
            `/api/marketplace/engagements/${timeline.id}/download-documents?${queryParams}`,
            {
                responseType: 'blob',
            }
        );
        return response;
    };

    const downloadFile = async (engagementDocument: EngagementDocument) => {
        const response = await fetchDocument(engagementDocument.id);
        if (response.status !== 200) {
            createNotification(
                'An unexpected error occurred while downloading document',
                'error'
            );
            return;
        }
        const fileName = engagementDocuments.engagementDocuments.find(
            (doc) => doc.id == engagementDocument.id
        )?.fileName;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const confirmDocumentWithFeedback = (docId: string) => {
        setIsDocConfirming(true);
        axios
            .post(
                `/api/Marketplace/Engagements/${props.timelineId}/${docId}/confirm-engagement-document`
            )
            .then((response) => {
                if (response.status === 200) {
                    fetchEngagement();
                    fetchEngagementDocuments(currentSort);
                    createNotification(
                        'Document approved successfully',
                        'success'
                    );
                    return;
                }

                createNotification(
                    'Some unexpected error occurred while approving document.',
                    'error'
                );
            })
            .catch(() => {
                createNotification(
                    'Some unexpected error occurred while approving document.',
                    'error'
                );
            })
            .finally(() => {
                setIsDocConfirming(false);
            });
    };

    useEffect(() => {
        const mappedDocuments = documents.map((doc) => {
            return {
                ...doc,
                isSelected: false,
            };
        });
        setDocuments(mappedDocuments);
    }, [props.isSelectModeEnabled]);

    const closeBuyerProfile = () => {
        setIsBuyerProfilePopupVisible(false);
        setSelectedEngagedBuyer(null);
    };

    const getQuestionnaireButton = (row: EngagementDocumentWithSelect) => {
        return (
            <Button
                onClick={() => {
                    const project =
                        timeline.engagementData.dataRequestProjects.find(
                            (p) => p.id === row.linkedProjectId
                        );
                    if (
                        project.status ===
                        LinkedDataRequestProjectStatus.Completed
                    ) {
                        updateDataRequestProjectStatus(
                            project.id,
                            LinkedDataRequestProjectStatus.InProgress
                        );
                    }
                    navigate(`${window.location.pathname}?tab=6`, {
                        state: {
                            projectId: project.dataRequestProjectId,
                            questionnaireId: row.questionnaireId,
                        },
                    });
                }}
                className="btn btn-primary"
                color="primary">
                Edit
            </Button>
        );
    };

    const updateDataRequestProjectStatus = (
        projectId: string,
        status: LinkedDataRequestProjectStatus
    ) => {
        axios
            .put(
                `/api/Marketplace/Engagements/${props.timelineId}/DataRequests/${projectId}/status`,
                status,
                {
                    headers: { 'Content-type': 'application/json' },
                }
            )
            .then((response) => {
                if (response.status !== 200) {
                    return;
                }
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while updating the status.',
                    'error'
                );
            });
    };

    const navigateToDocumentDiscussion = async (
        commsId: number,
        row: EngagementDocumentWithSelect
    ) => {
        if (!commsId) {
            return;
        }
        let discussionId = row.brokerChatDiscussionId;
        if (!row.brokerChatDiscussionId) {
            discussionId = await createDiscussionForDocument(
                row.id,
                commsId,
                row.name,
                `Document discussion: ${row.name}`
            );
        }
        if (!discussionId) {
            createNotification('Failed to create discussion', 'error');
            return;
        }
        navigate(
            `/marketplace/engagement/${timeline.id}?tab=${8}&subtab=${1}`,
            {
                state: {
                    discussionId: discussionId,
                },
            }
        );
    };

    const createDiscussionForDocument = async (
        docId: string,
        commsId: number,
        name: string,
        description: string
    ) => {
        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${timeline.id}/documents/${docId}/Comms/${commsId}`,
                {
                    name: name,
                    description: description,
                    isRemovable: false,
                }
            );
            if (response && response.status === 200) {
                return response.data;
            } else {
                const message = response?.data?.title;
                createNotification(message || '', 'error');
                return null;
            }
        } catch (e) {
            createNotification(
                'An error occurred while creating discussion',
                'error'
            );
            return null;
        }
    };

    const getActionButtons = (
        cellContent: EngagementDocumentStatus,
        row: EngagementDocumentWithSelect
    ) => {
        const isDocWithFeedback =
            row.type === ActionDocumentType.DocumentWithFeedback;
        const isPipDocument =
            (row.contentType === DocumentDetailsContentType.PipOrPiq &&
                row.source === EngagementDocumentSource.AdminUpload) ||
            row.source === EngagementDocumentSource.BrokerUpload;
        const isPiqDocument =
            row.contentType === DocumentDetailsContentType.PipOrPiq &&
            row.source === EngagementDocumentSource.Questionnaire;
        const isFinancialModel =
            row.contentType === DocumentDetailsContentType.FinancialModel;
        const isMaster = row?.id === row.masterDocumentId;
        const isMultiDoc =
            (isPipDocument || isFinancialModel) &&
            !!row.additionalVersionIds &&
            row.additionalVersionIds.length > 0;
        const isBrokerAssignedAndIsActive =
            !!timeline.engagementProcess?.broker &&
            timeline.engagementProcess?.broker?.isActive;

        const event = getEventForDocument(row?.id);
        const showUpdateFileBrokerBtn =
            isBroker &&
            ((row.counterParty === EngagementDocumentCounterParty.Seller &&
                row.type == ActionDocumentType.DocumentWithFeedback &&
                (isPipDocument || isFinancialModel)) ||
                row.isManualDocument);
        const showUpdateFileAdminBtn =
            isAdmin &&
            row.counterParty === EngagementDocumentCounterParty.Seller &&
            (((row.type == ActionDocumentType.Downloadable ||
                row.type == ActionDocumentType.Readonly) &&
                event?.status !== TimelineEventStatus.Completed) ||
                (row.type == ActionDocumentType.DocumentWithFeedback &&
                    row.source !== EngagementDocumentSource.Questionnaire));

        const getPiqApproveButtonText = (row: EngagementDocumentWithSelect) =>
            row.questionnaireId &&
            documents.find(
                (d) =>
                    d.questionnaireId === row.questionnaireId &&
                    d.questionnaireSnapshotId
            )
                ? 'Post Update to Buyers'
                : 'Approve';

        const shouldShowApproveButton = () => {
            if (isDocWithFeedback && isMaster) {
                if (
                    row.source === EngagementDocumentSource.AdminUpload ||
                    row.source === EngagementDocumentSource.BrokerUpload
                ) {
                    if (!row.fileUrl) return false;
                    if (
                        row.additionalVersionIds &&
                        row.additionalVersionIds.length > 0
                    ) {
                        const additionalDocs = documents.filter((d) =>
                            row.additionalVersionIds.includes(d.id)
                        );
                        if (additionalDocs.some((d) => !d.fileUrl))
                            return false;
                    }
                    return true;
                }
                if (row.source === EngagementDocumentSource.Questionnaire) {
                    if (!row.linkedProjectId || !row.questionnaireId)
                        return false;
                    return true;
                }
                return false;
            }
            return false;
        };

        return cellContent === EngagementDocumentStatus.RequiresAction &&
            row.type === ActionDocumentType.ForSign &&
            !isAdmin &&
            !isBroker ? (
            <ButtonLoader
                key={row?.id}
                buttonText="Execute Document"
                onClick={() => setDocumentToSignId(row?.id)}
                isLoading={
                    documentToSignId === row?.id && props.isGettingForSign
                }
                loaderButtonText="Execute Document"
                disabled={row.isDisabled}
                className={'btn btn-primary execute-document-button'}
            />
        ) : showUpdateFileAdminBtn || showUpdateFileBrokerBtn ? (
            <Button
                onClick={() =>
                    row.isManualDocument
                        ? setManualDocumentToUpdate(row?.id)
                        : setDocumentToUploadFile(row?.id)
                }
                className="btn btn-primary"
                color="primary">
                {row.isPrepared ? 'Update File' : 'Upload File'}
            </Button>
        ) : cellContent === EngagementDocumentStatus.RequiresAction &&
          isDocWithFeedback &&
          (!isPiqDocument || row.hasPendingChanges) &&
          !isAdmin &&
          !isBroker ? (
            <div className="feedback-buttons-container">
                {shouldShowApproveButton() ? (
                    <>
                        <Button
                            onClick={() => {
                                const popupHeader = isPipDocument
                                    ? 'Practice Information Package Approval'
                                    : isPiqDocument
                                    ? 'Practice Information Questionnaire Approval'
                                    : isFinancialModel
                                    ? 'Financial Model Approval'
                                    : 'Document Approval';
                                setDocumentApprovalPopupHeader(popupHeader);
                                setIsMultiDocumentApproval(isMultiDoc);
                                setDocumentWithFeedbackId(row?.id);
                                setIsApprovalPopupVisible(true);
                            }}
                            className="btn btn-primary"
                            color="primary">
                            {isPiqDocument
                                ? getPiqApproveButtonText(row)
                                : 'Approve'}
                        </Button>
                    </>
                ) : (
                    []
                )}
                {row.source === EngagementDocumentSource.Questionnaire
                    ? getQuestionnaireButton(row)
                    : []}
                {(timeline.levelOfService ==
                    LevelOfService.FullServiceBrokerage ||
                    timeline.levelOfService ==
                        LevelOfService.StrategicFinancialAdvisoryService) &&
                isBrokerAssignedAndIsActive &&
                !isPiqDocument &&
                isMaster ? (
                    <Button
                        onClick={() =>
                            navigateToDocumentDiscussion(
                                timeline.engagementProcess?.broker
                                    ?.brokerChatId,
                                row
                            )
                        }
                        className="btn btn-primary feedback-button"
                        color="primary">
                        Provide Feedback
                    </Button>
                ) : timeline.levelOfService ==
                      LevelOfService.DiscountBrokerage &&
                  !isPiqDocument &&
                  isMaster ? (
                    <ContactSupportButton
                        supportContext={SupportContextEnum.Marketplace}
                        buttonType="button"
                        buttonText="Provide Feedback"
                        hideIcon
                    />
                ) : (
                    []
                )}
            </div>
        ) : row.source === EngagementDocumentSource.Questionnaire &&
          !row.questionnaireSnapshotId ? (
            getQuestionnaireButton(row)
        ) : (
            <></>
        );
    };

    const isQuestionnaireSnapshot = (row: EngagementDocument) => {
        return row.isManualDocument && row.questionnaireSnapshotId;
    };

    const getDocumentColumns = () =>
        [
            props.isSelectModeEnabled && {
                dataField: 'id',
                text: 'Select',
                headerClasses: 'document-select-column-header',
                formatter: (
                    cellContent: string,
                    row: EngagementDocumentWithSelect
                ) => (
                    <input
                        key={cellContent}
                        type="checkbox"
                        checked={
                            row.isSelected ??
                            props.selectedDocumentsIds.includes(cellContent)
                        }
                        disabled={
                            !props.downloadableDocDetailsFilterCondition(
                                row as unknown as DocumentDetails
                            )
                        }
                        onChange={() => {
                            props.onDocumentSelected(cellContent);
                        }}
                    />
                ),
            },
            {
                dataField: 'name',
                text: 'Name',
                headerClasses: 'document-name-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (cellContent: string, row: EngagementDocument) => {
                    const isPipDocument =
                        (row.contentType ===
                            DocumentDetailsContentType.PipOrPiq &&
                            row.source ===
                                EngagementDocumentSource.AdminUpload) ||
                        row.source === EngagementDocumentSource.BrokerUpload;
                    const isFinancialModel =
                        row.contentType ===
                        DocumentDetailsContentType.FinancialModel;
                    const showEditBtnForBroker =
                        isBroker &&
                        ((row.counterParty ===
                            EngagementDocumentCounterParty.Seller &&
                            row.type ==
                                ActionDocumentType.DocumentWithFeedback &&
                            (isPipDocument || isFinancialModel)) ||
                            row.isManualDocument);
                    const editButton = () =>
                        party === TimelineParty.VetValue ||
                        showEditBtnForBroker ||
                        isQuestionnaireSnapshot(row) ? (
                            <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="doc-edit-icon"
                                onClick={(e) => {
                                    setDocumentToEditName(row);
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                            />
                        ) : (
                            <></>
                        );
                    if (!cellContent) {
                        return 'NA';
                    }

                    if (
                        row.type === ActionDocumentType.DocumentWithFeedback &&
                        row.contentType ===
                            DocumentDetailsContentType.PipOrPiq &&
                        row.source === EngagementDocumentSource.Questionnaire
                    ) {
                        return (
                            <a
                                className="doc-name"
                                onClick={() => {
                                    if (
                                        timeline.levelOfService ===
                                        LevelOfService.DiscountBrokerage
                                    ) {
                                        const project =
                                            timeline.engagementData.dataRequestProjects.find(
                                                (p) =>
                                                    p.id ===
                                                    row?.linkedProjectId
                                            );
                                        setLinkedProjectToView(project);
                                        setQuestionnaireDocument(row);
                                        setIsProjectItemViewPopupVisible(true);
                                    }
                                }}>
                                {cellContent}
                                {editButton()}
                                <NotificationFlag
                                    eventCode={`${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`}
                                    includePrefix={true}
                                />
                            </a>
                        );
                    }

                    if (
                        !row.isPrepared ||
                        (row.type === ActionDocumentType.ForSign &&
                            row.status !== EngagementDocumentStatus.Completed)
                    ) {
                        return (
                            <div className="doc-name-no-file">
                                {cellContent}
                                {editButton()}
                                <NotificationFlag
                                    eventCode={`${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`}
                                    includePrefix={true}
                                />
                            </div>
                        );
                    }

                    return (
                        <a
                            className="doc-name"
                            onClick={() => {
                                if (row.type === ActionDocumentType.Readonly) {
                                    getPdfUrl(row?.id);
                                } else {
                                    downloadFile(row);
                                }
                            }}>
                            {cellContent}
                            {editButton()}
                            <NotificationFlag
                                eventCode={`${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`}
                                includePrefix={true}
                            />
                        </a>
                    );
                },
            },
            {
                dataField: 'counterParty',
                text: 'Counter Party',
                headerClasses: 'counter-party-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (
                    cellContent: EngagementDocumentCounterParty,
                    row: EngagementDocument
                ) => {
                    const buyerId = row.engagementBuyerId;
                    if (buyerId) {
                        const selectedBuyer =
                            timeline.engagementProcess.buyers.find(
                                (f) => f.buyerId === buyerId
                            );
                        if (selectedBuyer) {
                            return (
                                <div
                                    className="link-text"
                                    onClick={() => {
                                        setSelectedEngagedBuyer(selectedBuyer);
                                        setIsBuyerProfilePopupVisible(true);
                                    }}>
                                    {selectedBuyer.companyName}
                                </div>
                            );
                        }
                    }
                    return EngagementDocumentCounterPartyOptions[cellContent];
                },
            },
            {
                dataField: 'datePosted',
                text: 'Date Posted',
                sort: !props.engagementDocumenstSection.isLetterSection,
                headerClasses: 'date-posted-column-header',
                formatter: (cellContent: Date) => (
                    <div>
                        {cellContent
                            ? moment(cellContent).format('M/D/YYYY')
                            : 'NA'}
                    </div>
                ),
            },
            {
                dataField: 'deadline',
                text: 'Deadline / Date Executed',
                sort: !props.engagementDocumenstSection.isLetterSection,
                headerClasses: 'deadline-column-header',
                formatter: (cellContent: Date) => (
                    <div>
                        {cellContent
                            ? moment(cellContent).format('M/D/YYYY')
                            : 'NA'}
                    </div>
                ),
            },
            props.isAdminView && {
                dataField: 'source',
                text: 'Document Source',
                headerClasses: 'document-source-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (cellContent: EngagementDocumentSource, row: any) =>
                    EngagementDocumentSourceOptions[cellContent],
            },
            props.isAdminView && {
                dataField: 'type',
                text: 'Type',
                headerClasses: 'type-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (cellContent: ActionDocumentType) =>
                    DocumentDetailsTypesOptions[cellContent],
            },
            {
                dataField: 'status',
                text: 'Status',
                headerClasses: 'status-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (
                    cellContent: EngagementDocumentStatus,
                    row: EngagementDocument
                ) => {
                    let status = EngagementDocumentStatusOptions[cellContent];
                    if (row.type === ActionDocumentType.DocumentWithFeedback) {
                        if (
                            row.status ===
                            EngagementDocumentStatus.RequiresAction
                        ) {
                            status = 'Draft';
                        }
                        if (row.status === EngagementDocumentStatus.Completed) {
                            status = 'Posted';
                        }
                    }
                    return <div className="status-container">{status} </div>;
                },
            },
            {
                dataField: 'status',
                text: 'Actions',
                headerClasses: 'buttons-column-header',
                sort: false,
                formatter: (
                    cellContent: EngagementDocumentStatus,
                    row: EngagementDocumentWithSelect
                ) => {
                    let masterOfdDoc: DocumentDetails;
                    let event: TimelineEvent;
                    const isMaster = row?.id == row.masterDocumentId;

                    if (isMaster) {
                        event = timeline.events.find(
                            (e) => e.linkedAction?.referenceItemId === row?.id
                        );
                    } else {
                        masterOfdDoc =
                            timeline.engagementData.documentsList.find(
                                (d) =>
                                    d?.id == row.masterDocumentId &&
                                    !!d.additionalVersionIds &&
                                    d.additionalVersionIds.includes(row?.id)
                            );
                        event = timeline.events.find(
                            (e) =>
                                e.linkedAction?.referenceItemId ===
                                masterOfdDoc?.id
                        );
                    }

                    const doc = masterOfdDoc ?? row;
                    const stillShowButtonOnCompletedEvent =
                        doc.type == ActionDocumentType.DocumentWithFeedback &&
                        (isAdmin ||
                            (!doc.isManualDocument &&
                                doc.questionnaireId &&
                                !doc.questionnaireSnapshotId));

                    return stillShowButtonOnCompletedEvent ||
                        (event?.status !== TimelineEventStatus.Completed &&
                            !props.isReadOnly &&
                            timeline.engagementProcess.status !==
                                EngagementProcessStatus.Completed) ? (
                        <div className="buttons-container">
                            {getActionButtons(cellContent, row)}
                        </div>
                    ) : (
                        <></>
                    );
                },
            },
        ].filter(Boolean);

    const isDfmDocument = (docId: string) => {
        const doc = documents.find((d) => d?.id === docId);
        return (
            doc.type === ActionDocumentType.DocumentWithFeedback &&
            doc.contentType === DocumentDetailsContentType.FinancialModel
        );
    };

    return (
        <div className="document-section">
            {props.buttonsSection ? props.buttonsSection : []}
            <CollapsibleComponent
                isExpanded={isExpanded}
                onToggle={(isExpanded) => {
                    setIsExpanded(isExpanded);
                }}
                header={props.engagementDocumenstSection.name}
                notificationFlag={`${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}`}>
                <div
                    role="tabpanel"
                    id={`panel-${props.engagementDocumenstSection.id}`}
                    aria-labelledby={`tab-${props.engagementDocumenstSection.id}`}
                    aria-hidden="false">
                    <div className="card-body">
                        <BootstrapTable
                            striped
                            bordered
                            bootstrap4
                            remote
                            keyField="id"
                            data={documents}
                            columns={getDocumentColumns()}
                            defaultSorted={defaultSorted}
                            filter={filterFactory()}
                            headerClasses="header-vetrical-align-top"
                            pagination={undefined}
                            onTableChange={handleTableChange}
                            noDataIndication="No Documents to display"
                            rowStyle={{ height: '44px' }}
                            rowClasses={(row, index) => {
                                if (selectedDocumentId === row?.id) {
                                    return index % 2
                                        ? 'highlighted'
                                        : 'highlighted-dark';
                                }

                                return '';
                            }}
                        />
                    </div>
                </div>
            </CollapsibleComponent>
            {isDocModalVisible ? (
                <EngagementDocumentPdfPreview
                    isVisible={isDocModalVisible}
                    pdfUrl={pdfUrl}
                    onClose={() => setIsDocModalVisible(false)}
                />
            ) : (
                []
            )}
            {documentToSign ? (
                <DocumentSignModal
                    documentId={documentToSign}
                    isVisible={!!documentToSign}
                    onClose={() => setDocumentToSign(undefined)}
                    onSign={() => {
                        setTimeout(() => {
                            fetchEngagement();
                            fetchEngagementDocuments(currentSort);
                            setDocumentToSign(undefined);
                            createNotification(
                                'Document signed successfully',
                                'success'
                            );
                        }, 2000);
                    }}
                />
            ) : (
                []
            )}

            {documentToUploadFile ? (
                <EngagementDocumentUploadModal
                    isOpen={!!documentToUploadFile}
                    onClose={() => setDocumentToUploadFile(undefined)}
                    onUpload={() => {
                        fetchEngagement();
                        fetchEngagementDocuments(currentSort);
                        setDocumentToUploadFile(undefined);
                    }}
                    documentId={documentToUploadFile}
                />
            ) : (
                []
            )}

            {manualDocumentToUpdate && (
                <ManualFileUploadPopup
                    engagementId={props.timelineId}
                    documentDetailsList={timeline.engagementData.documentsList}
                    isVisible={!!manualDocumentToUpdate}
                    setIsVisible={() => setManualDocumentToUpdate(undefined)}
                    documentsSections={
                        timeline.engagementData.documentSectionsList
                    }
                    sectionsModalMode={'external-modal'}
                    documentId={manualDocumentToUpdate}
                />
            )}

            {isProjectItemViewPopupVisible && linkedProjectToView ? (
                <ProjectItemViewPopup
                    isVisible={isProjectItemViewPopupVisible}
                    setIsVisible={(visible: boolean) => {
                        setIsProjectItemViewPopupVisible(visible);
                        if (!visible) {
                            setLinkedProjectToView(undefined);
                            setQuestionnaireDocument(undefined);
                        }
                    }}
                    questionnaireDocument={questionnaireDocument}
                    engagementStartDate={timeline.engagementProcess.startDate}
                    linkedProject={linkedProjectToView}
                />
            ) : (
                <></>
            )}
            {isBuyerProfilePopupVisible ? (
                <BuyerProfilePreviewPopup
                    buyerId={selectedEngagedBuyer.buyerId}
                    close={closeBuyerProfile}
                />
            ) : (
                <></>
            )}
            {isApprovalPopupVisible && (
                <ConfirmationModal
                    header={documentApprovalPopupHeader}
                    isVisible={isApprovalPopupVisible}
                    setIsVisible={setIsApprovalPopupVisible}
                    confirmationText={
                        isDfmDocument(documentWithFeedbackId)
                            ? dfmDocBody
                            : isMultiDocumentApproval
                            ? multiDocBody
                            : singleDocBody
                    }
                    params={''}
                    onConfirm={() =>
                        confirmDocumentWithFeedback(documentWithFeedbackId)
                    }
                    nextButtonText="Confirm Approval"
                    cancelButtonText="Cancel & Close"
                    isLoading={isDocConfirming}
                />
            )}

            {documentToEditName && (
                <EditDocumentNamePopup
                    document={documentToEditName}
                    engagementId={props.timelineId}
                    isVisible={!!documentToEditName}
                    onClose={() => setDocumentToEditName(undefined)}
                />
            )}
        </div>
    );
};

export default SellersEngagementDocumentsSection;
